import { render } from "./YellowBanner.vue?vue&type=template&id=1acca50c&scoped=true"
import script from "./YellowBanner.vue?vue&type=script&lang=js"
export * from "./YellowBanner.vue?vue&type=script&lang=js"

import "./YellowBanner.vue?vue&type=style&index=0&id=1acca50c&lang=scss&scoped=true"

import exportComponent from "/var/vsts_agent/_work/1505/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1acca50c"]])

export default __exports__